import type * as appointments from '@seen/core/models/appointments/index'
import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { buildAppointmentRelativeUrl } from '#src/stores/calendar.ts'
import { forwardRef } from '#src/utils/forwardRef.ts'

type AppointmentLinkProps = {
  appointment: appointments.ExtendedAppointment
  className?: string
} & Omit<ComponentPropsWithoutRef<typeof Link>, 'to' | 'className'>

export const AppointmentLink = forwardRef<
  ElementRef<typeof Link>,
  AppointmentLinkProps
>(({ appointment, className, ...delegated }, ref) => (
  <Link
    ref={ref}
    to={buildAppointmentRelativeUrl(appointment)}
    className={cn(
      'inline-flex items-center gap-1 text-muted-foreground text-sm',
      className
    )}
    {...delegated}
  >
    {delegated.children}
  </Link>
))
